import MapMixin from 'js/mixins/map.js'
import SidepanelMixin from 'js/mixins/stops-sidepanel-mixin'

import template from './index.pug'

// @vue/component
export default Vue.extend({
  name: 'google-link-only-page',
  template: template(),
  mixins: [MapMixin, SidepanelMixin],

  data() {
    return {
      googleMapsUrl: GOOGLE_MAPS_URL
    }
  },

  watch: {
    sidePanelOpen() {
      setTimeout(() => this.map.invalidateSize(true), 250)
    }
  }
})
